import { useNavigate } from 'react-router-dom';
import '../styles/global.css';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div style={{ background: 'var(--teal)', minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px', textAlign: 'center' }}>
      <div style={{ marginBottom: '24px', fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '24px', color: 'white' }}>
        BUMP <span style={{ color: '#F68F7C' }}>&#x2665;&#xFE0E;</span> BABY IMAGING
      </div>
      <div className="card" style={{ maxWidth: '440px', width: '100%' }}>
        <div style={{ fontSize: '64px', marginBottom: '12px' }}>👶</div>
        <h2 style={{ fontFamily: 'Nunito, sans-serif', fontWeight: 800, fontSize: '22px', color: 'var(--teal-dark)', marginBottom: '10px' }}>Oops! Page not found</h2>
        <p style={{ fontSize: '14px', color: 'var(--text-soft)', lineHeight: '1.6', marginBottom: '24px' }}>
          Looks like this little one wandered off! The page you're looking for doesn't exist.
        </p>
        <button className="btn-primary" onClick={() => navigate('/')}>Take Me Home</button>
        <p style={{ marginTop: '14px', fontSize: '13px', color: 'var(--text-soft)' }}>
          Need help? Contact us at <a href="mailto:info@bumpbabyimaging.com.au" style={{ color: 'var(--teal)', fontWeight: 700 }}>info@bumpbabyimaging.com.au</a>
        </p>
      </div>
    </div>
  );
}
